import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { environment } from '@environments/environment';
import { ConsultationStorageService } from '@services/consultation-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ParamTransactionIdGuard {
  private consultationStorageService = inject(ConsultationStorageService);

  /**
   * Determines if the route page should be loaded based on order_id parameter.
   * Verifies that an order_id parameter exists in the URL query parameters.
   *
   * @param {ActivatedRouteSnapshot} route The activated route snapshot
   * @returns {boolean} true if the order_id parameter is present, false otherwise
   */
  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const orderId = route.queryParams['order_id'];

    if (orderId) {
      return true;
    }

    window.location.href = environment.siteUrls.tests;

    return false;
  }
}
